import styled, { css } from 'styled-components';
import {Container, Title, Video} from '@components';
import { breakpoints } from '@config';
import vectorBg from './vector.svg';

const OFFSET_FOR_MOBILE = '105px';

export const Wrapper = styled.section`
  position: relative;
  height: 100vh;
  padding-bottom: ${OFFSET_FOR_MOBILE};
  margin-bottom: 64px;

  @media (min-width: ${breakpoints.pc}) {
    padding-bottom: 0;
    margin-bottom: 120px;
  }
`;

export const StyledContainer = styled(Container)`
  height: calc(100vh + ${OFFSET_FOR_MOBILE});

  @media (min-width: ${breakpoints.pc}) {
    height: 100vh;
  }
`;

export const StyledVideo = styled(Video)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: calc(100% - ${OFFSET_FOR_MOBILE});
  object-fit: cover;
  object-position: center center;

  @media (min-width: ${breakpoints.pc}) {
    height: 100%;
  }
`;

export const Shadow = styled.div`
  position: absolute;
  left: 0;
  bottom: ${OFFSET_FOR_MOBILE};
  width: 100%;
  height: 60%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);

  @media (min-width: ${breakpoints.pc}) {
    bottom: 0;
  }
`;

export const Head = styled.div`
  display: grid;
  grid-template: repeat(2, max-content) / repeat(2, 1fr);
  grid-template-areas: "title    title "
                       "link     link  "
                       "textures models";
  gap: 24px;
  padding-bottom: 48px;

  @media (min-width: ${breakpoints.pc}) {
    grid-template: repeat(2, max-content) / minmax(min-content, 520px) 1fr repeat(2, max-content);
    grid-template-areas: "title . .        .     "
                         "link  . textures models";
    gap: 32px 64px;
  }
`;

export const StyledTitle = styled(Title)`
  grid-area: title;

  @media (min-width: ${breakpoints.pc}) {
    padding-right: 62px;
  }
`;

export const Link = styled.div`
  grid-area: link;
  margin-bottom: 98px;

  @media (min-width: ${breakpoints.pc}) {
    margin-bottom: 0;
  }
`;

const Vector = css`
  position: relative;
  padding-left: 48px;
  
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 37px;
    height: 26px;
    background-image: url("${vectorBg}");
    background-repeat: no-repeat;
  }
`;

export const Textures = styled.div`
  grid-area: textures;
  ${Vector}
`;

export const Models = styled.div`
  grid-area: models;
  ${Vector}
`;

export const Value = styled.div`
  font-size: ${({ theme }) => theme.fontSize.lg}px;
  font-weight: 600;
  line-height: 1.1;
  letter-spacing: -2px;
`;
